import React, { useContext, useState } from "react";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import "./DeletePagamento.css";
import { Button } from "antd";
import { AuthContext } from "../../../contexts/AuthContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as links from "../../../utils/links";
import question_icon from "../../../assets/images/question.png";
import axios from "axios";

const DeletePagamento = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
    const { dataUser } = authInfo;
    const [isLoading, setIsLoading] = useState(false);
    const token = authInfo?.dataUser?.token;
    const { id } = useParams();

    const deleteHandler = async () => {
        setIsLoading(true);
        const config = {
            method: "delete",
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_SERVIDOR}/delete-pagamentos/${id}`,
            headers: {
                "x-access-token": token,
                "Content-Type": "application/json"
            }
        };

        try {
            await axios.request(config);
            setNotiMessage({ type: "success", message: "Acerto zerado com sucesso." });
            navigate(`${links.FORNECEDOR_SEARCH_CANAIS}/${id}`, { state: location.state });
        } catch (err) {
            if ([401, 403].includes(err?.response?.status)) {
                setNotiMessage({ type: "error", message: "Não foi possível zerar o acerto." });
                if (dataUser?.key === "ADMIN") {
                    navigate(links.ADMIN_SIGNIN);
                } else {
                    navigate(links.SIGNIN);
                }
                setDataUser(null);
            } else {
                setNotiMessage({ type: "error", message: err?.response?.data?.error || "Não foi possível zerar o acerto." });
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="PagamentosSearch_container">
            {isLoading && <LoadingAction />}
            <div className="Update_Pagamento_Content">
                <img className="Update_Pagamento_Icon" src={question_icon} alt="question icon" />
                <p className="Update_Pagamento_Text">Deseja zerar o acerto do mês desta máquina?</p>
                <div className="Update_Pagamento_Btns">
                    <Button
                        className="Update_Pagamento_Cancel_Btn"
                        disabled={isLoading}
                        onClick={() => navigate(`${links.FORNECEDOR_SEARCH_CANAIS}/${id}`, { state: location.state })}
                    >
                        <span>NÃO</span>
                    </Button>{" "}
                    <Button
                        className="Update_Pagamento_Delete_Btn action-delete"
                        danger
                        disabled={isLoading}
                        onClick={deleteHandler}
                    >
                        <span>SIM, ZERAR ACERTO</span>
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default DeletePagamento;
